import { Component, Inject, OnInit, ChangeDetectorRef  } from '@angular/core';
import {  MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClaimContact, vClaimContact } from '@app/_models/claimContact';
// import { DialogData } from '@app/_models/dialogData.model';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '@app/_services/rest.service';
import { UntypedFormBuilder, UntypedFormGroup, FormArray } from '@angular/forms';
import { AlertService } from '@app/_services/alert.service';
import { ClaimContactRole } from '@app/_models/claimContactRole.model';
import Swal from 'sweetalert2';
import { GlobalValues } from '@app/_services/global-values';
import { Employee } from '@app/_models/employee.model';
import { Note } from '@app/_models/note';
import { DatePipe } from '@angular/common';
import { catchError, concatMap, first } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-contact-detail',
  templateUrl: './contact-detail.component.html',
  styleUrls: ['./contact-detail.component.scss']
})
export class ContactDetailComponent implements OnInit {
  contactForm!: UntypedFormGroup;
  refNo!:number;
  clientId!:number;
  isEditable: boolean[] = [];
  isLoading: boolean = false;
  claimContact: ClaimContact[] = [];
  oldClaimContact: ClaimContact[] = [];
  claimContactRoles: ClaimContactRole[] = [];
  previousPrimaryIndex: number | null = null;
  isAddNewContact: boolean = false;
  newNote!:Note;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ContactDetailComponent>, 
    public dialog: MatDialog,
    private globalValues: GlobalValues,
    private datePipe: DatePipe, 
    private fb: UntypedFormBuilder,
    private restService: RestService,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
    ){
      this.claimContact = data.claimContact;
      this.oldClaimContact = JSON.parse(JSON.stringify(data.claimContact));
      this.refNo=data.refNo;
      this.clientId=data.clientId;
      this.isAddNewContact = data.isAddNewContact? data.isAddNewContact : false;
      this.alertService.clear();
    }

    ngOnInit(): void {
      console.log(this.isAddNewContact);
      if(this.isAddNewContact){
        this.addNewContact();
      }
      this.fetchRoles();
      this.cdr.detectChanges();
      this.contactForm = this.fb.group({
        contacts: this.fb.array([]), 
      });
    }
    
    fetchRoles() {
      this.restService.getClaimContactsRole().subscribe(
        roles => {
          this.claimContactRoles = roles;
        },
        error => {
          console.error('Fetch roles failed', error);
        }
      );
    }
    getRoleNameById(id: number): string {
      const role = this.claimContactRoles.find(role => role.contactTypeID === id);
      return role ? role.contactPerson : 'Unknown';
    }
    
    addNewContact(): void {
      // Create a new contact object with default values
      let newContact = {
        refno: this.data.claimContact[0].refNo,
        name: '',
        phone: '',
        emailAddress: '',
        claimContactRoleID: 0,
        note: '',
        // ... other properties with default values
        primaryContact: false // This ensures the checkbox is unchecked
      };
      // Add the new contact to your data array
      this.data.claimContact.push(newContact);
      //revese order of array to make sure new contact is at the top
      this.data.claimContact.reverse();
      this.setEditable(0, true);
    }
    validateAndSetPhone(event: Event, contact: any): void {
      // Cast the event target to an HTMLInputElement to access the value
      let inputElement = event.target as HTMLInputElement;
      
      // Replace any non-digit characters with an empty string
      inputElement.value = inputElement.value.replace(/\D/g, '');
      
      // Now, update the contact with the cleaned value
      contact.phone = inputElement.value;
      
      // Call your update method if necessary
      this.updateField({ value: contact.phone }, contact, 'phone');
    }
    
    
    updateField(event: any, contact: any, field: string) {
      if (field === 'primaryContact' && contact.primaryContact && !event.target.checked) {
        event.preventDefault();
        return;
      }
      contact[field] = event.target ? (event.target.type === 'checkbox' ? event.target.checked : event.target.value) : '';
      if (field === 'primaryContact') {
        if (contact.primaryContact) {
          console.log('This contact is now set as primary.');
        } else {
          console.log('This contact is no longer set as primary.');
        }
      }

      if (field === 'claimContactRoleID') {
        contact[field] = Number(event.target.value);
      } else if (field === 'primaryContact') {
        contact[field] = event.target.checked;
      } else {
        contact[field] = event.target.value;
      }
    }

    setEditable(index: number, editable: boolean) {
      this.isEditable[index] = editable;
    }
    
    saveContact(index: number): void {
      let isValid =  this.validateContact(index);
      if(isValid)
        {
          this.isLoading = true; 
          this.newNote = {
            refNo: this.refNo,
            date: this.datePipe.transform(new Date(), 'yyyy-MM-dd')?.toString()!,
            addedBy: this.globalValues.userName,
            initiatedBy: "Mk3 Staff",
            noteTypeId: 4,
            subTypeId: 6,
            reasonId: 3,
            notes: this.globalValues.userName + ' has updated the Customer Contact for Claim RefNo '+this.data.refNo+' at '+ this.datePipe.transform(new Date(), 'HH:mm yyyy-MM-dd')?.toString()! + ' for -\n',// + notes.join('. \n'),
            private: 0,//-1 = Private, 0 = Public
            timeStamp: null,
            followUpDate: null,
            followUpUser: null,
            followUpComplete: null,
            clientId: this.data.clientId,//null,
            isExternalAssessorVisible:false,
            addedById:this.data.userDetail.employeeId,
            claimNoteInitiatedById:1,
            isNotifyTeam:false,
          };
          if(this.isAddNewContact && index == 0){
            const newContact: ClaimContact = this.claimContact[index];
            newContact.name = this.claimContact[index].name;
            newContact.claimContactRoleID = this.claimContact[index].claimContactRoleID;
            newContact.phone = this.claimContact[index].phone;
            newContact.emailAddress = this.claimContact[index].emailAddress;
            newContact.note = this.claimContact[index].note;
            newContact.primaryContact = this.claimContact[index].primaryContact;
            newContact.lastModifiedByEmployeeID = this.data.userDetail.employeeId;

            //noteStr.push('Added a new Contact for claim RefNo '+this.data.refNo+', the contact details are - '+JSON.stringify(newContact));
            if (newContact.primaryContact == true) {
              //noteStr.push('. And the Primary Contact of existing Contact of '+this.claimContact[this.claimContact.length - 1].name +' Contact ID:'+ this.claimContact[this.claimContact.length - 1].contactID)+ ' has removed since the new Contact was marked as Primary Contact';
              const patchDocument = [
                { op: "replace", path: "/primaryContact", value: false }
              ];
              this.newNote.notes +=' The Primary Contact of existing Contact ID:'+ this.claimContact[this.claimContact.length - 1].contactID.toString() +' for '+this.claimContact[this.claimContact.length - 1].name+ ' has updated from True to False since the new Contact was marked as Primary Contact!';
              this.restService.patchClaimContact(this.claimContact[this.claimContact.length - 1].contactID, patchDocument)
                .pipe(
                  first(),
                   concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
                    catchError((error) => {
                        this.alertService.clear();
                        const err = (error.error instanceof ErrorEvent)? `Error: ${error.error.message}`: error;
                        this.alertService.error(err);
                        return throwError(err);
                      })
                    )
                    .subscribe({
                      next: () => {
                        this.setEditable(index, false);
                        this.isLoading = false
                      }
                    });
                
            }
            let { lastModifiedByEmployeeID, ...contact } = newContact;
            this.newNote.notes += ' Added a new Contact of - '+JSON.stringify(contact);
            this.restService.postClaimContact(newContact, this.data.refNo)
            .pipe(
              first(),
              concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
                catchError((error) => {
                    this.alertService.clear();
                    const err = (error.error instanceof ErrorEvent)? `Error: ${error.error.message}`: error;
                    this.alertService.error(err);
                    Swal.fire('New Contact Created, but failed to add new note! Please contact IT Desktop for support if you find your update not successful!', '', 'error');
                    return throwError(err);
                  })
                )
                .subscribe({
                  next: () => {
                    this.setEditable(index, false);
                    this.isLoading = false
                    Swal.fire('New Contact Created successfully, and new note has been added successfully!', '', 'success');
                  }
                });
            // .subscribe(
            //   () => {
            //     console.log('Created successfully');
            //     this.setEditable(index, false);
            //     this.isLoading = false
            //   },
            //   error => {
            //     console.error('Create failed', error);
            //     this.isLoading = false
            //   }
            // );
        }
      else {
        const updatedContact: ClaimContact = this.claimContact[index];
        // Index 0 is always the primary contact
        if (updatedContact.primaryContact) {
          if (this.claimContact[0].contactID != this.claimContact[index].contactID) {
            const patchDocument = [
              { op: "replace", path: "/primaryContact", value: false }
            ];
            this.newNote.notes += ' The Primary Contact of existing Contact of Contact ID:'+ this.claimContact[0].contactID+' for '+this.claimContact[0].name +' has updated from True to False. \n And the Primary Contact of existing Contact of Contact ID:' + this.claimContact[index].contactID +' for '+this.claimContact[index].name+' has updated from False to True.';
            this.restService.patchClaimContact(this.claimContact[0].contactID, patchDocument)
              .pipe(
                first(),
                concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
                  catchError((error) => {
                      this.alertService.clear();
                      const err = (error.error instanceof ErrorEvent)? `Error: ${error.error.message}`: error;
                      this.alertService.error(err);
                      //Swal.fire('New Contact Created, but failed to add new note! Please contact IT Desktop for support if you find your update not successful!', '', 'error');
                      return throwError(err);
                    })
                  )
                  .subscribe({
                    next: () => {
                      this.setEditable(index, false);
                      this.isLoading = false
                      //Swal.fire('New Contact Created successfully, and new note has been added successfully!', '', 'success');
                    }
                  });
            // .subscribe(
            //   () =>{+
            //     Swal.fire('Primary contact updated successfully!', '', 'success').then(()=>{
            //     this.setEditable(index, false);
            //     this.isLoading = false
            //     });
            //   },
            //   error => {
            //     console.error('Update failed', error);
            //     this.isLoading = false
            //   });
          }
          updatedContact.lastModifiedByEmployeeID = this.data.userDetail.employeeId;
          // Update the new primary contact
          this.newNote.notes += ' The exisiting Contact of of Contact ID:'+this.oldClaimContact[index].contactID+ ' has updated - for \n'+ this.getContactChanges(this.oldClaimContact[index] , updatedContact).join('. \n');
          this.restService.putClaimContact(updatedContact)
            .pipe(
              first(),
              concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
                catchError((error) => {
                    this.alertService.clear();
                    const err = (error.error instanceof ErrorEvent)? `Error: ${error.error.message}`: error;
                    this.alertService.error(err);
                    Swal.fire('Contact Updated, but failed to add new note! Please contact IT Desktop for support if you find your update not successful!', '', 'error');
                    return throwError(err);
                  })
                )
                .subscribe({
                  next: () => {
                    this.setEditable(index, false);
                    this.isLoading = false
                    Swal.fire('Contact Updated successfully, and new note has been added successfully!', '', 'success');
                  }
                });
          // .subscribe(
          //   () => {
          //     Swal.fire('successfully saved!', '', 'success').then(()=>{
          //       this.previousPrimaryIndex = index;  // Set the new primary index
          //       this.setEditable(index, false);
          //       this.isLoading = false
          //       this.isLoading=false;
          //     })
          //   },
          //   error => {
          //     console.error('Update failed', error);
          //     this.isLoading = false
          //   }
          // );
        } else if (this.claimContact[0].primaryContact == false) {
          return;
        }
        else {
          // Normal update
          updatedContact.lastModifiedByEmployeeID = this.data.userDetail.employeeId;
          updatedContact.claimContactRoleID = this.claimContact[index].claimContactRoleID;
          this.newNote.notes += ' Exisiting Contact of of Contact ID: has updated - for \n'+ this.getContactChanges(this.oldClaimContact[index], updatedContact).join('. \n');
          this.restService.putClaimContact(updatedContact)
            .pipe(
              first(),
              concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
                catchError((error) => {
                    this.alertService.clear();
                    const err = (error.error instanceof ErrorEvent)? `Error: ${error.error.message}`: error;
                    this.alertService.error(err);
                    Swal.fire('Contact Updated, but failed to add new note! Please contact IT Desktop for support if you find your update not successful!', '', 'error');
                    return throwError(err);
                  })
                )
                .subscribe({
                  next: () => {
                    this.setEditable(index, false);
                    this.isLoading = false
                    Swal.fire('Contact Updated successfully, and new note has been added successfully!', '', 'success');
                  }
                });
          // .subscribe(
          //   () => {
          //     Swal.fire('successfully saved!', '', 'success').then(()=>{
          //     this.setEditable(index, false);
          //     this.isLoading = false
          //     });
          //   },
          //   error => {
          //     console.error('Update failed', error);
          //     this.isLoading = false
          //   }
          // );
        }
      }
    }
  }

    getContactChanges(oldContact:ClaimContact, newContact:ClaimContact): string[] {
      let changes:string[]=[];
      if (oldContact.name!==newContact.name){
        changes.push('The Contact name changed from ' + oldContact.name+' to '+ newContact.name);
      }
      if (oldContact.claimContactRoleID!==newContact.claimContactRoleID){
        changes.push('The Contact role changed from ' + this.getRoleNameById(oldContact.claimContactRoleID)+' to '+ this.getRoleNameById(Number(newContact.claimContactRoleID)));
      }
      if (oldContact.phone!==newContact.phone){
        changes.push('The Contact phone changed from ' + oldContact.phone+' to '+ newContact.phone);
      }
      if (oldContact.emailAddress!==newContact.emailAddress){
        changes.push('The Contact email address changed from ' + oldContact.emailAddress+' to '+ newContact.emailAddress);
      }
      if (oldContact.note!==newContact.note){
        changes.push('The Contact note changed from ' + oldContact.note+' to '+ newContact.note);
      }
      if (oldContact.lastModifiedByEmployeeID!==newContact.lastModifiedByEmployeeID){
        changes.push('The Contact last modified by employee ID changed from ' + oldContact.lastModifiedByEmployeeID+' to '+ newContact.lastModifiedByEmployeeID);
      }
      return changes;
    }

    validateContact(index: number): boolean{
      let isValid = true;

      if(!this.claimContact[index].claimContactRoleID)
        {
          isValid=false;
        }

        return isValid;

    }
    
    currentPrimaryIndex: number | null = null;

    setPrimaryContact(index: number): void {
      if (this.currentPrimaryIndex !== null) {
        this.claimContact[this.currentPrimaryIndex].primaryContact = false;
      }
      
      this.claimContact[index].primaryContact = true;
      this.currentPrimaryIndex = index;
    }


    
    onNoClick(): void {
      this.dialogRef.close();
      if(this.isAddNewContact){
        this.data.claimContact.reverse()
        this.data.claimContact.pop();
      }

    }
  
    closeDialog() {
      this.dialogRef.close();
      if(this.isAddNewContact){
        this.data.claimContact.reverse()
        this.data.claimContact.pop();
      }
    }
   
}
